import styled from "styled-components";
import {MATERIAL_INFO, MATERIAL_SHADES} from "../../helper/materials";
import {ConfigurateurContext} from "../../context/context";
import {Tooltip} from "react-tooltip";

const {
    element: {
        useContext,
    },
} = wp;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  
    & .label {
      margin-top: 10px;
      font-size: 13px;
      font-weight: 700;
    }
    & .sub-label {
        font-size: 13px;
        font-weight: 500;
    }
    & input[type=radio] {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;
    }
    & input[type=radio] + .radio-image {
      cursor: pointer;          
    }
    & input[type=radio]:checked + .radio-image {
      border: 3px solid #144344;
      border-radius: 12px;
    }
`;
const ImageContainer = styled.div`
    border-radius: 8px;
    border: 1px solid #DBDBDB;
    & img {
      max-height: 78px;
    }
`;
export default function ShadeItem({mid, imageUrl, label, subLabel, handleSelect}) {

    const {setCurrentShade, currentShade} = useContext(ConfigurateurContext);

    const handleClick = () => {
        setCurrentShade(mid);
        setTimeout(() => handleSelect(), 300);
    }
    return(
        <>
            <Wrapper
                data-tooltip-id="finition-tooltip"
                data-tooltip-content={MATERIAL_INFO[mid]}
            >
                <label>
                    <input type="radio" name="shade" value={mid} checked={mid === currentShade} />
                    <ImageContainer onClick={handleClick} className="radio-image">
                        <img src={imageUrl} alt={mid} />
                    </ImageContainer>
                </label>
                <span className="label">{label}</span>
                { subLabel && <span className="sub-label">{subLabel}</span> }
            </Wrapper>
            <Tooltip
                id="finition-tooltip"
                className="hjt-tooltip"
                style={{ backgroundColor: "#CCC", color: "#222" }}
            />
        </>
    );
}